import dayjs from 'dayjs'

/**
 * Monta as linhas da grid de digitação mensal.
 *
 * A API (quase) sempre amplia o período em um dia para cada lado — o cálculo precisa
 * dos vizinhos para jornadas que atravessam a meia-noite (`listDias` em
 * working-day-of-employee.usecase.ts). Esses dias de borda não pertencem à
 * competência: o dia anterior é sempre descartado e o dia seguinte só é
 * exibido para funcionário com horário noturno.
 *
 * Corta sem mutar: `jornadas` é o array do cache do react-query, e remover
 * itens dele com `splice`/`pop` apagaria os dias de borda para todo mundo que
 * lê a mesma query.
 */
export function montarLinhasMensal<T extends { dia: string }>(
    jornadas: T[],
    isHorarioNoturno: boolean,
    periodo: [string, string],
): Array<T & { id: number }> {
    const primeiro = jornadas.at(0)
    const ultimo = jornadas.at(-1)

    const cortaInicio =
        !isHorarioNoturno &&
        !!primeiro &&
        dayjs.utc(periodo[0]).isAfter(dayjs.utc(primeiro.dia))

    const cortaFim =
        !isHorarioNoturno &&
        !!ultimo &&
        dayjs.utc(periodo[1]).isBefore(dayjs.utc(ultimo.dia))

    return jornadas
        .slice(cortaInicio ? 1 : 0, cortaFim ? -1 : undefined)
        .map((jornada, index) => ({ ...jornada, id: index + 1 }))
}
